import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { KotlinLoggingConfiguration_getInstance2afdiujdk3hao as KotlinLoggingConfiguration_getInstance } from './KotlinLoggingConfiguration.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  Level_TRACE_instance = new (Level())('TRACE', 0, 0, 'TRACE');
  Level_DEBUG_instance = new (Level())('DEBUG', 1, 10, 'DEBUG');
  Level_INFO_instance = new (Level())('INFO', 2, 20, 'INFO');
  Level_WARN_instance = new (Level())('WARN', 3, 30, 'WARN');
  Level_ERROR_instance = new (Level())('ERROR', 4, 40, 'ERROR');
  Level_OFF_instance = new (Level())('OFF', 5, 50, 'OFF');
}
var Level_TRACE_instance;
var Level_DEBUG_instance;
var Level_INFO_instance;
var Level_WARN_instance;
var Level_ERROR_instance;
var Level_OFF_instance;
var LevelClass;
function Level() {
  if (LevelClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, levelInt, levelStr) {
        super(name, ordinal);
        this.k2i_1 = levelInt;
        this.l2i_1 = levelStr;
      }
      m2i() {
        return this.e5(KotlinLoggingConfiguration_getInstance().h2h_1.n2i()) >= 0;
      }
      toString() {
        return this.l2i_1;
      }
    }
    initMetadataForClass($, 'Level');
    LevelClass = $;
  }
  return LevelClass;
}
function Level_DEBUG_getInstance() {
  static_init();
  return Level_DEBUG_instance;
}
function Level_INFO_getInstance() {
  static_init();
  return Level_INFO_instance;
}
function Level_ERROR_getInstance() {
  static_init();
  return Level_ERROR_instance;
}
//region block: exports
export {
  Level_DEBUG_getInstance as Level_DEBUG_getInstance1dj873l5gwu6j,
  Level_ERROR_getInstance as Level_ERROR_getInstance8a6cbaqpnh7n,
  Level_INFO_getInstance as Level_INFO_getInstance1jaw01kotd0ox,
};
//endregion

//# sourceMappingURL=Level.mjs.map
